export default {
    PREMIER_INN: 9,
    TRAVEL_LODGE: 10,
};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/config/supplier.constant.js